module.exports = __webpack_public_path__ + "img/btn-tower@3x.af842c07.png";